import styles from './styles.module.css';

import logo from '../../../../assets/images/logo-light.png';

export function Mark() {
  return (
    <>
      <div
        className={`${styles.mark} animate__animated animate__fadeIn shadow`}
      >
        <a target="_blank" href="https://oqdigital.com">
          <img
            src={logo}
            width={20}
            height={20}
            style={{ marginRight: '5px' }}
            alt=""
          />
          OQ Digital
        </a>
      </div>
    </>
  );
}
